export default __webpack_public_path__ + "static/media/benefit-3@3x.63fb2d10.png";